import { Box, Icon, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import ChunkContainer from './ChunkContainer';
import HalfCircleProgressBar from './HalfCircularProgressBar';
import Title from './Title';
import { PROGRESS_SIZE_X, SMILEY_SIZE } from '../utils/constants';
import getColor from '../utils/getColor';
import getSmileyIcon from '../utils/getSmileyIcon';

type Props = {
  percentage: number;
  title: string;
  onClick?: () => void;
  loading: boolean;
  LoadingAnimation: ReactNode;
};

export default function PercentageChunk({
  percentage,
  title,
  onClick,
  loading,
  LoadingAnimation,
}: Props) {
  return (
    <ChunkContainer
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      _hover={onClick ? { transform: 'scale(1.05)' } : {}}
      transition={onClick ? 'transform 0.2s' : ''}
    >
      <Title text={title} />
      {loading ? (
        LoadingAnimation
      ) : (
        <Box
          style={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <HalfCircleProgressBar
            color={getColor(percentage)}
            bgColor="#FFFEFE"
            progress={percentage}
            progressSize={PROGRESS_SIZE_X}
          />
          <Icon
            zIndex="1"
            marginTop="50px"
            boxSize={`${SMILEY_SIZE}px`}
            as={getSmileyIcon(percentage)}
          />
          <Text
            zIndex="1"
            fontSize="65px"
            textAlign="center"
            fontFamily="poppins-bold"
            color="livelinx.purple200"
          >
            {percentage}%
          </Text>
        </Box>
      )}
    </ChunkContainer>
  );
}
